import { BasicSelectDrop } from '@playbooks/molecules/drops';

const ComposerTypes = ({ type, types = [], entity = 'project', onSelect }) => {
	// Render
	return (
		<BasicSelectDrop
			id='agent_composer_type_drop'
			value={String(type.id || '')}
			prevIcon='layer-group'
			placeholder={entity === 'agent' ? 'Agent type' : 'Project type'}
			options={types.map(item => String(item.id))}
			labels={Object.fromEntries(types.map(item => [String(item.id), item.name]))}
			descriptions={Object.fromEntries(types.map(item => [String(item.id), item.description]))}
			size='sm'
			onChange={id => onSelect(types.find(item => String(item.id) === id))}
			className='w-auto min-w-32 flex-none bg-surface'
		/>
	);
};

export { ComposerTypes };
